import React from "react";
import { createIcon } from "@chakra-ui/icons";

export const VisaColor = createIcon({
  displayName: "VisaColor",
  viewBox: "0 0 212 128",
  defaultProps: {
    role: "img"
  },
  path: (
    <>
      <title> Visa pay icon with color </title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M107.983 54.8415C107.898 61.5233 113.961 65.2521 118.529 67.4691C123.222 69.7441 124.798 71.2028 124.78 73.2367C124.744 76.3501 121.036 77.7238 117.566 77.7773C111.512 77.8709 107.992 76.1492 105.193 74.8469L103.013 85.0121C105.82 86.3014 111.019 87.4255 116.411 87.4745C129.065 87.4745 137.345 81.2521 137.39 71.6042C137.439 59.3601 120.387 58.682 120.503 53.209C120.544 51.5497 122.133 49.7787 125.617 49.3283C127.341 49.101 132.101 48.9268 137.497 51.4023L139.615 41.5673C136.714 40.5145 132.983 39.5062 128.34 39.5062C116.429 39.5062 108.05 45.8134 107.983 54.8415ZM159.968 40.3537C157.657 40.3537 155.709 41.6965 154.841 43.7572L136.763 86.7519H149.409L151.925 79.8246H167.379L168.839 86.7519H179.984L170.258 40.3537H159.968ZM161.737 52.8877L165.386 70.3104H155.391L161.737 52.8877ZM92.6506 40.3537L82.6827 86.7519H94.7328L104.696 40.3537H92.6506ZM74.8238 40.3537L62.2809 71.934L57.2073 45.0818C56.6119 42.0846 54.261 40.3537 51.6502 40.3537H31.1458L30.8591 41.701C35.0686 42.6108 39.851 44.0784 42.7481 45.6485C44.5212 46.6073 45.0275 47.4459 45.6095 49.7253L55.2191 86.7519H67.9548L87.4786 40.3537H74.8238Z"
        fill="#1A1F71"
      />
      <rect
        x="0"
        y="0"
        width="100%"
        height="100%"
        stroke="#C4C4C4"
        rx="10"
        strokeWidth="1"
        fill="transparent"
      />
    </>
  )
});
